import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-ca367df6")

_pushScopeId("data-v-ca367df6")
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_3 = { class: "text-red-lp-100" }
const _hoisted_4 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_5 = {
  class: "w-full absolute z-50",
  style: {"border-bottom":"85px solid transparent"}
}
const _hoisted_6 = {
  key: 0,
  class: "flex justify-end p-2"
}
const _hoisted_7 = { class: "px-2 py-3 border-b border-gray-lp-400" }
const _hoisted_8 = { class: "px-2 py-3 border-b border-gray-lp-400" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Nama Partner/Client ", -1)
const _hoisted_10 = { class: "flex flex-row gap-y-4 my-2 lp-radio" }
const _hoisted_11 = { class: "p-field-radiobutton gap-x-3 flex flex-row" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "type1",
  class: "cursor-pointer"
}, "Partner", -1)
const _hoisted_13 = { class: "p-field-radiobutton ml-2 gap-x-3 flex flex-row" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "type2",
  class: "cursor-pointer"
}, "Client", -1)
const _hoisted_15 = { class: "px-2 py-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: 
      `advanced-filter inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2 ${_ctx.openFilter &&
        'w-400px'}`
    
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.openFilter && !_ctx.isDisabled ? 'rounded-t' : 'rounded'
        } border border-gray-lp-400 text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      ,
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
          _ctx.$emit('opened', _ctx.openFilter);
        }
      )
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", {
          class: _ctx.isDisabled && 'opacity-50'
        }, [
          _hoisted_2,
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.sumFilter !== 0 ? `(${_ctx.sumFilter})` : ""), 1)
        ], 2)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              alt: "up",
              src: _imports_0,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              alt: "down",
              src: _imports_1,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          )
            }, null, 2))
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _createVNode("div", {
        class: 
          `select bg-white border border-t-0 border-gray-lp-400 rounded-b-md px-1 ${_ctx.isScroll &&
            'overflow-y-auto'} overflow-x-show`
        ,
        style: {"max-height":"80vh"}
      }, [
        (_ctx.sumFilter > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                class: "cursor-pointer flex-initial items-end text-red-lp-100"
              }, " Reset ")
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, { label: "Tipe Transaksi" }, {
            default: _withId(() => [
              _createVNode(_component_Select, {
                onOpenSelect: _ctx.onOpenSelectTransactionType,
                onCloseSelect: _ctx.onCloseSelectTransactionType,
                isOpenMenu: _ctx.isOpenTransactionType,
                value: _ctx.advanceFilter.type,
                onChooseSelect: _ctx.onSelectTransactionType,
                dataSelect: _ctx.transactionTypeList,
                class: "w-full whitespace-no-wrap my-1.5"
              }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_RadioButton, {
                id: "type1",
                name: "city-exclude",
                value: "partner",
                "model-value": _ctx.advanceFilter.clientPartnerType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeClientPartnerType('partner'))),
                disabled: _ctx.isClientPartnerTypeDisabled
              }, null, 8, ["model-value", "disabled"]),
              _hoisted_12
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_RadioButton, {
                id: "type2",
                name: "city-exclude",
                value: "client",
                "model-value": _ctx.advanceFilter.clientPartnerType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeClientPartnerType('client'))),
                disabled: _ctx.isClientPartnerTypeDisabled
              }, null, 8, ["model-value", "disabled"]),
              _hoisted_14
            ])
          ]),
          _createVNode(_component_SelectSearch, {
            class: "my-1",
            onFilter: _ctx.fetchClientPartner,
            isLoading: _ctx.loadingClientPartner,
            options: _ctx.partnerClientData,
            keyName: "name",
            keyValue: "id",
            placeholder: "Pilih client/partner",
            modelValue: _ctx.advanceFilter.clientPartner,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.advanceFilter.clientPartner = $event)),
            onChange: _ctx.onChange,
            isDisabled: _ctx.advanceFilter.clientPartnerType === ''
          }, null, 8, ["onFilter", "isLoading", "options", "modelValue", "onChange", "isDisabled"])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_DataWrapper, { label: "Created By" }, {
            default: _withId(() => [
              _createVNode(_component_SelectSearch, {
                placeholder: "Pilih",
                modelValue: _ctx.advanceFilter.createdBy,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.advanceFilter.createdBy = $event)),
                options: _ctx.listCreatedBy,
                onFilter: _ctx.fetchCreatedBy,
                keyName: "createdName",
                keyValue: "createdId",
                isLoading: _ctx.isLoadingCreatedBy,
                class: "my-1.5"
              }, null, 8, ["modelValue", "options", "onFilter", "isLoading"])
            ]),
            _: 1
          })
        ])
      ], 2)
    ], 512), [
      [_vShow, _ctx.openFilter && !_ctx.isDisabled]
    ])
  ], 2)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.$emit('opened', true);
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.openFilter = false;
          _ctx.$emit('opened', false);
        }
      }
    ]
  ])
})